import { render, staticRenderFns } from "./received.vue?vue&type=template&id=6ec3b320&"
import script from "./received.js?vue&type=script&lang=js&"
export * from "./received.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports